import React from 'react';
import { Link } from 'react-router-dom';

const anpcUrl = 'https://customer-assets.emergentagent.com/job_canteen-orders-6/artifacts/ja4qp2qb_image.png';

const Footer = () => {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-cols">
          <div className="site-footer-col">
            <h4>Garden8 · MIRICOS BISTRO SRL</h4>
            <p>Bd. Dimitrie Pompeiu nr. 8<br />Sector 2, București</p>
            <p>CUI: RO 51428096<br />Reg. Com.: J2025017256004</p>
            <p>
              <a href="mailto:garden8.pipera@gmail.com">garden8.pipera@gmail.com</a><br />
              <a href="tel:+40731156700">0731 156 700</a>
            </p>
          </div>

          <div className="site-footer-col">
            <h4>Informații</h4>
            <ul>
              <li><Link to="/livrare" data-testid="footer-livrare">Livrare</Link></li>
              <li><Link to="/retur" data-testid="footer-retur">Retur & Anulare</Link></li>
              <li><Link to="/termeni" data-testid="footer-termeni">Termeni și Condiții</Link></li>
              <li><Link to="/gdpr" data-testid="footer-gdpr">Politică GDPR</Link></li>
              <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="site-footer-col site-footer-badges">
            <a
              href="https://anpc.ro/ce-este-sal/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-badge"
              data-testid="footer-anpc"
              title="ANPC — Soluționarea alternativă a litigiilor"
            >
              <img src={anpcUrl} alt="ANPC — Soluționarea alternativă a litigiilor" />
            </a>
          </div>
        </div>

        <div className="site-footer-bottom">
          © {new Date().getFullYear()} Garden8. Toate drepturile rezervate. Plăți procesate securizat prin Stripe.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
